export class UploadSizeMismatchError extends Error {
  public readonly errorCode: string;

  constructor(errorCode: string, message: string) {
    super(message);
    this.name = 'UploadSizeMismatchError';
    this.errorCode = errorCode;
  }
}
